<template>
    <Teleport to="body">
        <div class="modal" :id="id" tabindex="-1">
            <div class="modal-dialog modal-webnews">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <div class="ratio ratio-16x9">
                            <iframe :src="source" class="w-100 h-100" allowfullscreen
                                title="webpageshow_iframe"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>

export default {
    setup() {
    },
    name: "IframeModal",
    created() {
    },
    props: {
        source: String,
        id: String,
    },
    data() {
        return {
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        closeModal() {
            let modal = '#modal_' + this.id;
            $(modal).modal("hide");
        }
    }
};
</script>
